import moment from 'moment';
import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import HistoryService from '../services/HistoryService';
class HistoryListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new HistoryService());

        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statusOptions: [],
            roleTypeOptions: [],
            viewPortWidth: window.innerWidth,
        };
        this.setViewPortWidth = this.setViewPortWidth.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setViewPortWidth);
    }
    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.month && prevProps.month !== this.props.month) || (prevProps.userAgreementMap && prevProps.userAgreementMap !== this.props.userAgreementMap)) {
            const {criteria} = this.state;
            criteria.month = this.props.month;
            criteria.userAgreementMap = this.props.userAgreementMap;
            this.setState(
                {
                    loading: true,
                    criteria,
                    first: criteria.firstResult,
                },
                () => {
                    this.refreshTable();
                }
            );
        }
    }
    setViewPortWidth() {
        if (this.state.viewPortWidth > 467 && window.innerWidth < 468) {
            this.setState({viewPortWidth: window.innerWidth});
        }
        if (this.state.viewPortWidth < 468 && window.innerWidth > 467) {
            this.setState({viewPortWidth: window.innerWidth});
        }
    }
    getListTitle() {
        return 'history.listTitle';
    }
    prepareHeader() {
        return !!this.props.embedded ? null : super.prepareHeader();
    }
    updateSearchCriteria(criteria) {
        return {
            month: this.props.month,
            userAgreementMap: this.props.userAgreementMap,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }
    renderFilter() {
        return null;
    }
    labelHeader() {
        return null;
    }
    getCleanSearchCriteria() {
        return {
            month: this.props.month,
            userAgreementMap: this.props.userAgreementMap,
            firstResult: 0,
            maxResults: 10,
            sortField: 'date',
            sortAsc: false,
        };
    }
    afterGetListError() {
        this.props.handleError();
    }
    initializeFromBackend() {
        window.addEventListener('resize', this.setViewPortWidth);
    }

    getCriteriaName() {
        return 'history-list-sc';
    }

    getContainerListName() {
        return 'history-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderCriteria() {
        return null;
    }

    prepareColumns() {
        const {t} = this.props;
        let columns;
        if (this.state.viewPortWidth > 467) {
            columns = [
                {
                    field: 'date',
                    // header: t('history.date'),
                    body: (el) => {
                        return (
                            <div className='history-cell'>
                                <label className='history-label'>{t('profile.history.labelDate')}</label>
                                {moment(el.date).format('DD-MM-YYYY, HH:mm:ss')}
                            </div>
                        );
                    },
                },
                {field: 'action'},
                {
                    field: 'login',
                    body: (el) => {
                        return (
                            <div className='history-cell'>
                                <label className='history-label'>{t('profile.history.labelLogin')}</label>
                                {el.login}
                            </div>
                        );
                    },
                },
            ];
        } else {
            columns = [
                {field: 'action'},
                {
                    field: 'date',
                    // header: t('history.date'),
                    body: (el) => {
                        return (
                            <div className='history-cell'>
                                <label className='history-label'>{t('profile.history.labelDate')}</label>
                                {moment(el.date).format('DD-MM-YYYY, HH:mm:ss')}
                            </div>
                        );
                    },
                },
                {
                    field: 'login',
                    body: (el) => {
                        return (
                            <div className='history-cell'>
                                <label className='history-label'>{t('profile.history.labelLogin')}</label>
                                {el.login}
                            </div>
                        );
                    },
                },
            ];
        }
        return columns;
    }

    prepareHeaderItems() {
        return [{type: 'LABEL', className: 'float-left'}];
    }

    render() {
        // const { t } = this.props;
        return <div className='container-fluid history-list-container'>{this.renderView()}</div>;
    }
    renderView() {
        return (
            <DivContainer colClass=''>
                {/* <Messages id='custom-messages' ref={(el) => (this.messages = el)}></Messages> */}
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <Card
                        className='list-card'
                        // header={this.renderHeader()}
                    >
                        
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                        {this.renderDataTable(this.prepareColumns())}
                    </Card>
                </BlockUi>
            </DivContainer>
        );
    }
}

HistoryListContainer.defaultProps = {
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
};

HistoryListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    userId: PropTypes.number,
};

export default withTranslation()(HistoryListContainer);
